import { MISC, NP_NP, TO_BE_INITIATED, NOT_SETTLED, SETTLED } from "../constants/constants"
export const reconciliationData =
[
    {
        "Id": 1,
        "ReconciliationRequestId": 1,
        "SettlementRefNo": "123",
        "PaymentId": 123,
        "ReconciliationRequestItemStatusId": TO_BE_INITIATED,
        "Amount": {
            "Currency": "INR",
            "Value": "100"
        },
        "Comission": {
            "Currency": "INR",
            "Value": "10"
        },
        "WithholdingAmount": {
            "Currency": "INR",
            "Value": "20"
        },
        "TCS": {
            "Currency": "INR",
            "Value": "2"
        },
        "TDS": {
            "Currency": "INR",
            "Value": "3"
        },
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",
        "Remarks": "test"
    },
    {
        "Id": 2,
        "ReconciliationRequestId": 1,
        "SettlementRefNo": "123",
        "PaymentId": 123,
        "ReconciliationRequestItemStatusId": TO_BE_INITIATED,
        "Amount": {
            "Currency": "INR",
            "Value": "100"
        },
        "Comission": {
            "Currency": "INR",
            "Value": "10"
        },
        "WithholdingAmount": {
            "Currency": "INR",
            "Value": "20"
        },
        "TCS": {
            "Currency": "INR",
            "Value": "2"
        },
        "TDS": {
            "Currency": "INR",
            "Value": "3"
        },
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",     
        "Remarks": "test"
    }
]

